import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import BannersList, { bannersListLoader } from "./banners/List";
import BannerForm, { bannerFormLoader } from "./banners/Form";

/** Website content — the customer home page's banners — spread into the root route's children in main.tsx. */
export const websiteRoutes: RouteObject[] = [
  { path: "website/banners", Component: BannersList, loader: bannersListLoader, errorElement: <AppError /> },
  { path: "website/banners/new", Component: BannerForm, loader: bannerFormLoader, errorElement: <AppError /> },
  { path: "website/banners/:slug", Component: BannerForm, loader: bannerFormLoader, errorElement: <AppError /> },
];
